// extracted by mini-css-extract-plugin
export default {"root":"IconBin_root__fLuw4"};